import React from "react";
import styled, { css } from "styled-components";
import { colors, fonts, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import CheckboxFilter from "../../atoms/CheckboxFilter";
import { InterrogationRadio, InterrogationRadioGroup } from "../../atoms/InterrogationRadio";
import cross from "../../../assets/images/icons/cross.svg";

export const FilterTitle = styled.div`
  padding-bottom: 20px;
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const FilterWinesHolderContainer = styled.div`
  background-color: ${colors.white};
  padding: 30px;
  z-index: 3000;
  transition: ${transition.baseTransition};
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  width: 100%;
  ${breakpoints.smUp} {
    display: ${(props) => (props.filterWinesIsOpen ? "block" : "none")};
  }
  ${breakpoints.smDown} {
    padding: 15px 20px;
  }
`;

export const FilterWinesBodyHolder = styled.div`
  flex: 1;
  margin-bottom: 20px;
`;

export const FilterWinesTitle = styled.h1`
  text-transform: uppercase;
  font-family: ${fonts.fontInterstateUltraBlack};
  display: none;
  word-break: break-word;
  line-height: 0.9em;
  display: inline-block;
  margin-bottom: 15px !important;
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const FilterWinesCheckboxFilters = styled.div`
  margin-top: 20px;
  &:not(:last-child) {
    margin-bottom: 35px;
  }
`;

export const FilterWinesRangeFilters = styled.div`
  margin-top: 20px;
  &:not(:last-child) {
    margin-bottom: 35px;
  }
`;

export const FilterItem = styled.div`
  padding-bottom: ${(props) => (props.isOpen ? "20px" : "0px")};
  ${breakpoints.smUp} {
    max-width: 500px;
  }
  border: 0px solid ${colors.black};
  border-top-width: 2px;
  &:last-child {
    border-bottom-width: 2px;
  }
`;

export const SmallerCheckboxFilter = styled(CheckboxFilter)`
  margin-right: 10px;
  padding: 7px 15px;
  font-size: 10px;
`;

export const PricePointsCheckbox = styled(InterrogationRadioGroup)`
  width: 100%;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-top: 25px !important;
  &:before {
    bottom: 40px;
    width: 85%;
    left: 30px;
    ${breakpoints.xsDown} {
      bottom: 35px;
    }
  }
`;

const radioTextStyle = css`
  font-family: ${fonts.fontConceptRegular};
  font-size: 14px;
  padding-top: 40px;
  padding-bottom: 0;
  &:before {
    bottom: 20px;
  }
`;

const radioLabelStyle = css`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  &:first-child {
    min-width: 62px;
    text-align: left;
    > span {
      &:before {
        left: 10px;
      }
    }
  }
`;

export const InterrogationRadioComponent = (props) => (
  <InterrogationRadio {...props} radioLabelStyle={radioLabelStyle} radioTextStyle={radioTextStyle} />
);

export const loadingStyle = css`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 500px;
  background-color: white;
`;

export const BackButton = styled.div`
  cursor: pointer;
  width: 15px;
  margin-bottom: 20px;
`;

export const Cross = styled.img.attrs(() => ({ src: cross }))`
  height: 15px;
  width: 15px;
`;

// Fix the width to avoid filters bouncing around when the number of matches change
export const MatchCountContainer = styled.span`
  display: inline-block;
  width: 20px;
`;
